module.exports = __webpack_public_path__ + "img/lb-video.373c4921.svg";